import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarBrand,
  Navbar,
  Container,
} from "reactstrap";
import { useTranslation } from "context/TranslationProvider";
import userServices from "services/userServices";

function AuthNavbar({ logo }) {
  const { language, changeLanguage } = useTranslation();
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const res = await userServices.getLanguages();
        const dataObj = res?.data?.data || res?.data || res;
        const langList = Array.isArray(dataObj) ? dataObj : (dataObj?.languages || []);
        setLanguages(langList);
      } catch (err) {
        console.error("Failed to fetch languages", err);
      }
    };

    fetchLanguages();
  }, []);

  const selectedLang = languages.find((l) => l.code === language);

  return (
    <Navbar
      className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
      expand="lg"
      id="navbar-main"
    >
      <Container className="d-flex align-items-center justify-content-between flex-nowrap px-3">
        {logo && (
        <NavbarBrand className="d-flex align-items-center mr-0 ml-sm--3">
          <img
            alt={logo.imgAlt}
            className="navbar-brand-img navbar-brand-img-custom"
            src={logo.imgSrc}
          />
          <span className="navbar-brand-text text-orange font-weight-bold ml-2 ml-sm-0 h4 mb-0 d-inline-block">
            Bagmails
          </span>
        </NavbarBrand>
        )}

        <UncontrolledDropdown className="ml-auto ml-sm-0">
          <DropdownToggle
            className="btn btn-sm btn-neutral d-flex align-items-center"
            caret
          >
            {selectedLang && (
              <>
                <img
                  src={`https://flagcdn.com/w20/${selectedLang.flagCode}.png`}
                  alt={selectedLang.name}
                  className="mr-2 rounded-sm"
                />
                <span className="text-uppercase font-weight-bold">
                  {selectedLang.code}
                </span>
              </>
            )}
          </DropdownToggle>

          <DropdownMenu right className="dropdown-menu-arrow">
            {languages.map((lang) => (
              <DropdownItem
                key={lang.code}
                disabled={!lang.synced}
                onClick={() => changeLanguage(lang.code)}
                className="d-flex align-items-center"
              >
                <img
                  src={`https://flagcdn.com/w20/${lang.flagCode}.png`}
                  alt={lang.name}
                  className="mr-2 rounded-sm"
                />
                <span>{lang.name}</span>

                {lang.code === language && (
                  <span className="ml-auto text-muted">✓</span>
                )}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </Container>
    </Navbar>
  );
}

export default AuthNavbar;
